import { Component, OnInit, ElementRef, AfterContentInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'adminapp-step-tabs',
  templateUrl: './step-tabs.component.html',
  styleUrls: ['./step-tabs.component.scss'],
})
export class StepTabsComponent implements OnInit, AfterContentInit {

  constructor(private router: Router, private location: Location, private _elementRef: ElementRef) { }

  ngOnInit() {
  }

  ngAfterContentInit() {
    const content = this._elementRef.nativeElement.children;
    const currentHref = this.location.path();
    const router = this.router;
    for (let i = 0; i < content.length; i++) {
      const item = content[i];
      const href = item.pathname || item.getAttribute('ng-reflect-router-link');

      if (href) {
        const normalize = function (path) {
          let result = router.parseUrl(path).toString();
          if (result.indexOf('?') > -1) {
            result = result.split('?')[0];
          }
          return result;
        };

        const hrefUrl = normalize(href);
        const currentHrefUrl = normalize(currentHref);
        const currentConfig = this.router.config[0].children.find(c => {
          const iUrl = normalize(c.path);
          return iUrl === currentHrefUrl;
        });
        const itemConfig = this.router.config[0].children.find(c => {
          const iUrl = normalize(c.path);
          return iUrl === hrefUrl;
        });

        if (currentConfig && itemConfig && currentConfig.component === itemConfig.component) {
          item.classList.add('current');
        } else {
          item.classList.remove('current');
        }
      }
    }
  }
}
